import { env } from '../config/env.js';
import { updatePushSubscription } from '../api/user.service.js';

const urlBase64ToUint8Array = (base64String) => {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const normalized = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(normalized);
  const outputArray = new Uint8Array(rawData.length);

  for (let index = 0; index < rawData.length; index += 1) {
    outputArray[index] = rawData.charCodeAt(index);
  }

  return outputArray;
};

const isPushSupported = () =>
  typeof window !== 'undefined' &&
  'serviceWorker' in navigator &&
  'PushManager' in window &&
  'Notification' in window;

const ensureServiceWorkerRegistration = async () => {
  if (!isPushSupported()) {
    return null;
  }

  await navigator.serviceWorker.register('/sw.js');
  return navigator.serviceWorker.ready;
};

export const syncPushSubscription = async ({ requestPermission = false } = {}) => {
  if (!isPushSupported()) {
    return { status: 'unsupported' };
  }

  const registration = await ensureServiceWorkerRegistration();
  if (!registration) {
    return { status: 'unavailable' };
  }

  if (requestPermission && Notification.permission === 'default') {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      return { status: permission === 'denied' ? 'denied' : 'dismissed' };
    }
  }

  if (Notification.permission !== 'granted') {
    return { status: 'permission-not-granted' };
  }

  if (!env.VITE_VAPID_PUBLIC_KEY) {
    console.warn('Push notifications are enabled in the browser, but VAPID_PUBLIC_KEY is missing.');
    return { status: 'missing-vapid-key' };
  }

  let subscription = await registration.pushManager.getSubscription();
  if (!subscription) {
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(env.VITE_VAPID_PUBLIC_KEY),
    });
  }

  await updatePushSubscription(subscription.toJSON());
  return { status: 'subscribed', subscription };
};
